const messages = {
  title: 'Gateway timeout-feil',
  description: 'Vi beklager ulempene. Det ser ut til at serveren vår ikkje mottok et rettidig svar.',
  backHomeButton: 'Attende til dashbord'
}

export default {
  messages
}
